import axios from "./axios.js";

// 仓库列表
export function getWarehouseList(data) {
  return axios.request({
    method: 'POST',
    url: '/jeecg-boot/product/warehouse/list',
    data
  })
}